import React from 'react';
import { Avatar } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from '@/features/user/userApi';

const useBrokerDetails = () => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;
	const { data: userDetails } = useGetUserDetailsQuery({ email }, { skip: !email });
	return userDetails?.broker;
};

export const CrmAccountAvatar = () => {
	const brokerDetails = useBrokerDetails();

	if (brokerDetails?.imageUrl) {
		return (
			<Avatar
				sx={{
					width: 24,
					height: 24,
					backgroundColor: '#34495E',
				}}
				src={brokerDetails.imageUrl}
			/>
		);
	}

	return <AccountCircle sx={{ fontSize: 24 }} />;
};

export const CrmAccountLabel = () => {
	const brokerDetails = useBrokerDetails();
	return brokerDetails?.name ?? '';
};
